<template>
  <page layoutClass="projects-index" :loading="!applications">
    <!-- Header -->
    <b-row class="p-3">
      <b-col cols="12" sm="7">
        <h3 class="m-0">Your Applications</h3>
      </b-col>
    </b-row>
    <b-row v-if="Array.isArray(applications) && applications.length" class="p-3">
      <b-col
        cols="12"
        lg="4"
        v-for="application in applications"
        :key="application.id"
      >
        <b-card class="mb-3">
          <application-card :application="application" />
        </b-card>
      </b-col>
      <b-col cols="12" lg="4" class="pb-3">
        <b-card class="h-100" body-class="d-flex align-items-center justify-content-center text-center">
          <div>
            <div>Are you looking for more projects or jobs?</div>
            <div><b-link :to="{ name: 'ProjectsIndex' }">See all projects</b-link> or <b-link :to="{ name: 'InternalJobIndex' }">See all jobs</b-link></div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-else class="p-3">
      <b-col cols="12">
        <b-card class="p-5 mb-3 d-flex align-items-center justify-content-center text-center">
          <div>You have not submitted any applications yet.</div>
          <div><b-link :to="{ name: 'ProjectsIndex' }">See all projects</b-link> or <b-link :to="{ name: 'InternalJobIndex' }">See all jobs</b-link></div>
        </b-card>
      </b-col>
    </b-row>
  </page>
</template>

<script>
import Page from '@/components/Page';
import CurrentUserInternalApplicationsQuery from '@/graphql/queries/CurrentUserInternalApplications.gql';
import ApplicationCard from '@/components/profile/ApplicationCard.vue';

export default {
  components: {
    Page,
    ApplicationCard,
  },
  apollo: {
    applications: {
      query: CurrentUserInternalApplicationsQuery,
      update({ user }) {
        if (user) {
          const { applications } = user;
          if (Array.isArray(applications) && applications.length) {
            return applications;
          }
        }
        return [];
      },
      error(err) {
        this.$notifyFatalErr(err);
      },
      fetchPolicy: 'network-only',
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/User/Applications.vue